import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateOnlineScheduling = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1295.11 307.89",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{stroke:#7a4900;stroke-linejoin:round;stroke-width:3.61px;}.c,.d{fill:none;stroke-linecap:round;}.e{fill:#033a1e;}.f{fill:#0254cf;}.g{fill:#022c16;}.h{fill:#044e28;}.i{fill:#ebf3ff;}.j{fill:#fafcff;}.k{fill:#fff1d6;}.l{fill:#ffc700;}.m{fill:#e5fbee;}.n{fill:#9ec5ff;}.o{fill:#08873f;}.p{fill:#7a4900;}.d{stroke:#ebf3ff;stroke-miterlimit:10;stroke-width:4.13px;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("rect", {
				className: "j",
				width: 1295.11,
				height: 306.94
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("rect", {
						className: "i",
						x: 21.5,
						y: 62.02,
						width: 231.64,
						height: 204.55
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "h",
						d: "M36.14,41.32H238.5c8.08,0,14.64,6.56,14.64,14.64v59.08H21.5V55.96c0-8.08,6.56-14.64,14.64-14.64Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "h",
							d: "M81.31,160.46h-13.55v-12.22c0-1.14-1.02-2.06-2.28-2.06s-2.28,.92-2.28,2.06v12.22h-13.55c-1.26,0-2.28,.92-2.28,2.06s1.02,2.06,2.28,2.06h13.55v12.22c0,1.14,1.02,2.06,2.28,2.06s2.28-.92,2.28-2.06v-12.22h13.55c1.26,0,2.28-.92,2.28-2.06s-1.02-2.06-2.28-2.06Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "h",
							d: "M153.15,160.46h-13.55v-12.22c0-1.14-1.02-2.06-2.28-2.06s-2.28,.92-2.28,2.06v12.22h-13.55c-1.26,0-2.28,.92-2.28,2.06s1.02,2.06,2.28,2.06h13.55v12.22c0,1.14,1.02,2.06,2.28,2.06s2.28-.92,2.28-2.06v-12.22h13.55c1.26,0,2.28-.92,2.28-2.06s-1.02-2.06-2.28-2.06Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "h",
							d: "M225,160.46h-13.55v-12.22c0-1.14-1.02-2.06-2.28-2.06s-2.28,.92-2.28,2.06v12.22h-13.55c-1.26,0-2.28,.92-2.28,2.06s1.02,2.06,2.28,2.06h13.55v12.22c0,1.14,1.02,2.06,2.28,2.06s2.28-.92,2.28-2.06v-12.22h13.55c1.26,0,2.28-.92,2.28-2.06s-1.02-2.06-2.28-2.06Z"
						})
					] }),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "h",
							d: "M81.31,221.14h-13.55v-12.22c0-1.14-1.02-2.06-2.28-2.06s-2.28,.92-2.28,2.06v12.22h-13.55c-1.26,0-2.28,.92-2.28,2.06s1.02,2.06,2.28,2.06h13.55v12.22c0,1.14,1.02,2.06,2.28,2.06s2.28-.92,2.28-2.06v-12.22h13.55c1.26,0,2.28-.92,2.28-2.06s-1.02-2.06-2.28-2.06Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "h",
							d: "M153.15,221.14h-13.55v-12.22c0-1.14-1.02-2.06-2.28-2.06s-2.28,.92-2.28,2.06v12.22h-13.55c-1.26,0-2.28,.92-2.28,2.06s1.02,2.06,2.28,2.06h13.55v12.22c0,1.14,1.02,2.06,2.28,2.06s2.28-.92,2.28-2.06v-12.22h13.55c1.26,0,2.28-.92,2.28-2.06s-1.02-2.06-2.28-2.06Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "h",
							d: "M225,221.14h-13.55v-12.22c0-1.14-1.02-2.06-2.28-2.06s-2.28,.92-2.28,2.06v12.22h-13.55c-1.26,0-2.28,.92-2.28,2.06s1.02,2.06,2.28,2.06h13.55v12.22c0,1.14,1.02,2.06,2.28,2.06s2.28-.92,2.28-2.06v-12.22h13.55c1.26,0,2.28-.92,2.28-2.06s-1.02-2.06-2.28-2.06Z"
						})
					] }),
					/* @__PURE__ */ _jsx("rect", {
						className: "i",
						x: 57.55,
						y: 64.36,
						width: 159.55,
						height: 19.35,
						rx: 9.67,
						ry: 9.67
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "g",
						d: "M251.48,105.14c-3.61,0-4.87,3.85-6.1,7.58-.49,1.49-1.38,4.19-2.11,4.83-.73-.64-1.62-3.34-2.11-4.83-1.22-3.73-2.49-7.58-6.09-7.58s-4.87,3.85-6.1,7.58c-.48,1.49-1.38,4.19-2.1,4.83-.73-.64-1.62-3.34-2.11-4.83-1.23-3.73-2.49-7.58-6.08-7.58s-4.87,3.85-6.1,7.58c-.48,1.49-1.38,4.19-2.1,4.83-.73-.64-1.62-3.34-2.11-4.83-1.23-3.73-2.49-7.58-6.09-7.58s-4.87,3.85-6.1,7.58c-.48,1.49-1.38,4.19-2.11,4.83-.72-.64-1.62-3.34-2.1-4.83-1.23-3.73-2.49-7.58-6.1-7.58s-4.86,3.85-6.08,7.58c-.49,1.49-1.38,4.19-2.11,4.83-.72-.64-1.62-3.34-2.1-4.83-1.23-3.73-2.49-7.58-6.1-7.58s-4.86,3.85-6.09,7.58c-.49,1.48-1.36,4.14-2.09,4.81-.07-.05-.14-.11-.21-.2h-.01c-.04-.06-.08-.12-.12-.18-.65-1-1.37-3.16-1.78-4.44-.69-2.11-1.4-4.25-2.54-5.72-.88-1.16-2.01-1.91-3.6-1.91-3.6,0-4.87,3.85-6.09,7.58-.49,1.49-1.38,4.19-2.11,4.83-.08-.07-.16-.17-.24-.28-.66-.97-1.4-3.19-1.82-4.49-.77-2.34-1.56-4.73-2.93-6.18-.82-.89-1.85-1.45-3.22-1.45-3.6,0-4.87,3.85-6.09,7.58-.49,1.49-1.37,4.18-2.11,4.82-.72-.73-1.57-3.31-2.05-4.77-.84-2.57-1.7-5.19-3.34-6.58-.75-.66-1.66-1.06-2.81-1.06-3.6,0-4.86,3.85-6.09,7.58-.49,1.49-1.38,4.19-2.11,4.83-.73-.64-1.62-3.34-2.11-4.83-1.22-3.73-2.49-7.58-6.09-7.58s-4.86,3.85-6.09,7.58c-.49,1.49-1.38,4.19-2.11,4.83-.73-.64-1.62-3.34-2.11-4.83-1.22-3.72-2.49-7.58-6.09-7.58s-4.86,3.85-6.09,7.58c-.49,1.49-1.38,4.19-2.11,4.83-.73-.64-1.62-3.34-2.11-4.83-1.22-3.72-2.49-7.58-6.09-7.58s-4.86,3.85-6.09,7.58c-.49,1.49-1.38,4.19-2.11,4.83-.73-.64-1.62-3.34-2.11-4.83-1.22-3.73-2.49-7.58-6.09-7.58s-4.86,3.85-6.09,7.58c-.49,1.49-1.38,4.19-2.11,4.83-.73-.64-1.62-3.34-2.11-4.83-1.22-3.72-2.49-7.58-6.09-7.58s-4.86,3.85-6.09,7.58c-.49,1.49-1.38,4.19-2.11,4.83-.73-.64-1.62-3.34-2.11-4.83-1.22-3.72-2.49-7.58-6.09-7.58v3.74c-.06,0-.12-.02-.14-.03,.76,.39,1.72,3.34,2.24,4.92,1.22,3.72,2.49,7.58,6.09,7.58s4.86-3.85,6.09-7.58c.49-1.49,1.38-4.19,2.11-4.83,.73,.64,1.62,3.34,2.11,4.83,1.22,3.72,2.49,7.58,6.09,7.58s4.86-3.85,6.09-7.58c.49-1.49,1.38-4.19,2.11-4.83,.73,.64,1.62,3.34,2.11,4.83,1.22,3.73,2.49,7.58,6.09,7.58s4.86-3.85,6.09-7.58c.49-1.49,1.38-4.19,2.11-4.83,.73,.64,1.62,3.34,2.11,4.83,1.22,3.72,2.49,7.58,6.09,7.58s4.86-3.85,6.09-7.58c.49-1.49,1.38-4.19,2.11-4.83,.73,.64,1.62,3.34,2.11,4.83,1.22,3.72,2.49,7.58,6.09,7.58s4.86-3.85,6.09-7.58c.49-1.49,1.38-4.19,2.11-4.83,.73,.64,1.62,3.34,2.11,4.83,1.22,3.73,2.49,7.58,6.09,7.58s4.86-3.85,6.09-7.58c.49-1.48,1.37-4.16,2.1-4.82,.02,.01,.03,.02,.05,.03,.72,.7,1.59,3.32,2.07,4.79,.77,2.35,1.56,4.74,2.94,6.19,.82,.89,1.85,1.45,3.22,1.45,3.59,0,4.86-3.85,6.08-7.58,.49-1.49,1.38-4.19,2.1-4.83,.08,.07,.15,.17,.23,.27,.67,.97,1.4,3.19,1.83,4.5,.7,2.12,1.41,4.29,2.56,5.76,.87,1.14,2,1.88,3.57,1.88,3.61,0,4.87-3.85,6.1-7.58,.48-1.49,1.38-4.19,2.1-4.83,.09,.07,.17,.18,.26,.31,.66,.98,1.38,3.17,1.81,4.46,.62,1.88,1.25,3.79,2.18,5.22,.92,1.44,2.14,2.42,3.95,2.42,3.61,0,4.87-3.85,6.1-7.58,.48-1.49,1.38-4.19,2.1-4.83,.73,.64,1.62,3.34,2.11,4.83,1.23,3.73,2.49,7.58,6.09,7.58s4.87-3.85,6.1-7.58c.48-1.49,1.38-4.19,2.1-4.83,.73,.64,1.62,3.34,2.11,4.83,1.23,3.73,2.49,7.58,6.08,7.58s4.87-3.85,6.1-7.58c.49-1.49,1.38-4.19,2.11-4.83,.72,.64,1.62,3.34,2.1,4.83,1.23,3.73,2.49,7.58,6.1,7.58s4.86-3.85,6.08-7.58c.49-1.49,1.38-4.19,2.11-4.83,.72,.64,1.62,3.34,2.1,4.83,1.23,3.73,2.49,7.58,6.1,7.58s4.86-3.85,6.09-7.58c.49-1.49,1.38-4.19,2.11-4.83,.73,.64,1.62,3.34,2.11,4.83,1.22,3.73,2.48,7.58,6.08,7.58s4.87-3.85,6.1-7.58c.48-1.49,1.38-4.19,2.11-4.83,.54,.48,1.17,2.1,1.66,3.51v-6.99c-.49-.22-1.04-.33-1.66-.33Z"
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
					className: "f",
					cx: 283.57,
					cy: 193.87,
					r: 41.79
				}), /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
						className: "d",
						d: "M310.96,188.87c1.68,9.23-1.35,19.09-8.87,25.79-11.12,9.91-27.97,9.27-38.32-1.2"
					}), /* @__PURE__ */ _jsx("polygon", {
						className: "i",
						points: "305.42 192.57 307.99 180.5 317.16 188.76 305.42 192.57"
					})] }),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
						className: "d",
						d: "M256.96,202.09c-3.11-10.09-.31-21.52,8.08-29,11.48-10.23,29.08-9.22,39.31,2.26"
					}), /* @__PURE__ */ _jsx("polygon", {
						className: "i",
						points: "261.99 197.76 260.91 210.05 250.8 202.97 261.99 197.76"
					})] }),
					/* @__PURE__ */ _jsx("path", {
						className: "i",
						d: "M281.52,191.12v5.36c0,5.02,4.02,9.16,8.95,9.24,2.29,0,4.48-.86,6.17-2.42,1.68-1.55,2.71-3.65,2.9-5.91,.07-.69,.1-2.82,.1-3.52s-.02-2.83-.1-3.52c-.19-2.26-1.22-4.36-2.9-5.91-1.69-1.55-3.88-2.41-6.17-2.41-1.95,0-3.83,.63-5.39,1.79-.07,.06-.09,.19-.01,.3l1.9,3.16c.08,.1,.19,.11,.28,.04h0c.9-.75,2.04-1.18,3.22-1.18s2.37,.44,3.28,1.23c.9,.79,1.49,1.87,1.66,3.05,.11,.76,.13,2.67,.13,3.46s0,2.5-.13,3.43c-.16,1.18-.75,2.28-1.66,3.07-.92,.8-2.09,1.25-3.3,1.25h0c-1.3-.03-2.52-.56-3.43-1.5-.91-.94-1.42-2.18-1.42-3.49v-5.37c0-5.02-4.02-9.16-8.95-9.24-2.29,0-4.48,.86-6.16,2.42-1.68,1.55-2.71,3.65-2.9,5.91-.08,.69-.1,2.82-.1,3.52s.02,2.83,.1,3.52c.19,2.26,1.22,4.36,2.9,5.91,1.68,1.56,3.87,2.42,6.17,2.42,1.95,0,3.83-.63,5.39-1.79,.07-.06,.09-.19,.01-.3l-1.9-3.16c-.08-.1-.19-.11-.28-.04h0c-.9,.75-2.04,1.18-3.22,1.18s-2.37-.44-3.28-1.23c-.9-.79-1.49-1.87-1.66-3.05-.11-.76-.13-2.67-.13-3.46s0-2.5,.13-3.43c.16-1.18,.75-2.28,1.66-3.07,.92-.8,2.09-1.25,3.3-1.25h0c1.3,.03,2.52,.56,3.43,1.5,.9,.94,1.41,2.18,1.41,3.5h0Z"
					})
				] })] }),
				/* @__PURE__ */ _jsx("path", {
					className: "n",
					d: "M443.91,159.75l-30.84-17.8c-.67-.38-1.5,.1-1.5,.87v11.2h-62.06c-.53,0-.96,.43-.96,.96v11.29c0,.53,.43,.96,.96,.96h62.06v11.2c0,.77,.83,1.25,1.5,.87l30.84-17.8c.67-.38,.67-1.35,0-1.73Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "n",
					d: "M759.43,160.52l-30.84-17.8c-.67-.38-1.5,.1-1.5,.87v11.2h-62.06c-.53,0-.96,.43-.96,.96v11.29c0,.53,.43,.96,.96,.96h62.06v11.2c0,.77,.83,1.25,1.5,.87l30.84-17.8c.67-.38,.67-1.35,0-1.73Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "n",
					d: "M1078.2,160.52l-30.84-17.8c-.67-.38-1.5,.1-1.5,.87v11.2h-62.06c-.53,0-.96,.43-.96,.96v11.29c0,.53,.43,.96,.96,.96h62.06v11.2c0,.77,.83,1.25,1.5,.87l30.84-17.8c.67-.38,.67-1.35,0-1.73Z"
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "k",
					cx: 543.22,
					cy: 160.62,
					r: 67.01
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "p",
					d: "M538.42,184.17h-29.27v-5.03l13.13-16.46c2.55-3.2,5.1-6.93,5.1-12.09,0-4.77-1.7-10.13-7.25-10.13-1.57,0-3.92,.98-3.92,2.74,0,1.57,3,1.83,3,5.81,0,2.87-2.09,4.84-4.9,4.84-3.4,0-5.36-2.68-5.36-5.95,0-6.21,6.47-10.85,14.44-10.85,8.36,0,15.09,5.29,15.09,12.81,0,6.47-4.64,9.93-9.87,14.05-2.03,1.63-7.78,5.82-11.57,10.78h13.92c3.72,0,3.92-1.44,4.12-2.42,.33-1.7,.91-1.76,3.33-1.76v13.66Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "p",
					d: "M571.35,138.24v29.21h6.14v3.66h-6.14v6.14c0,2.68,.85,3.14,2.09,3.27,1.57,.2,1.7,.78,1.7,3.66h-17.9v-1.7c0-1.44,.85-1.7,1.7-1.89,1.31-.33,2.09-.91,2.09-3.33v-6.14h-16.33v-3.66l19.41-29.21h7.25Zm-10.32,11.3l-11.89,17.9h11.89v-17.9Z"
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "m",
						cx: 1192.77,
						cy: 162.69,
						r: 67.01
					}),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M1187.97,186.24h-29.27v-5.03l13.13-16.46c2.55-3.2,5.1-6.93,5.1-12.09,0-4.77-1.7-10.13-7.25-10.13-1.57,0-3.92,.98-3.92,2.74,0,1.57,3,1.83,3,5.81,0,2.87-2.09,4.84-4.9,4.84-3.4,0-5.36-2.68-5.36-5.95,0-6.21,6.47-10.85,14.44-10.85,8.36,0,15.09,5.29,15.09,12.81,0,6.47-4.64,9.93-9.87,14.05-2.03,1.63-7.78,5.82-11.57,10.78h13.92c3.72,0,3.92-1.44,4.12-2.42,.33-1.7,.91-1.76,3.33-1.76v13.66Z"
					}), /* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M1220.9,140.31v29.21h6.14v3.66h-6.14v6.14c0,2.68,.85,3.14,2.09,3.27,1.57,.2,1.7,.78,1.7,3.66h-17.9v-1.7c0-1.44,.85-1.7,1.7-1.89,1.31-.33,2.09-.91,2.09-3.33v-6.14h-16.33v-3.66l19.41-29.21h7.25Zm-10.32,11.3l-11.89,17.9h11.89v-17.9Z"
					})] }),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
						className: "o",
						cx: 1249.58,
						cy: 117.11,
						r: 24.04
					}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
						className: "i",
						d: "M1259.21,105.48c.02,.45-.15,.88-.46,1.2l-11.2,11.2c-.28,.28-.65,.48-1.04,.51-.48,.04-.93-.13-1.26-.46l-4.83-4.83c-.32-.32-.49-.76-.46-1.2,.02-.45,.23-.87,.58-1.15,.62-.52,1.58-.45,2.17,.14l3.64,3.64s.04,.02,.06,0l10.07-10.07c.59-.59,1.55-.65,2.17-.14,.35,.29,.55,.71,.58,1.16Z"
					}), /* @__PURE__ */ _jsx("path", {
						className: "i",
						d: "M1259.21,117.32c.02,.45-.15,.88-.46,1.2l-11.2,11.2c-.28,.28-.65,.48-1.04,.51-.48,.04-.93-.13-1.26-.46l-4.83-4.83c-.32-.32-.49-.76-.46-1.2,.02-.45,.23-.87,.58-1.15,.62-.52,1.58-.45,2.17,.14l3.64,3.64s.04,.02,.06,0l10.07-10.07c.59-.59,1.55-.65,2.17-.14,.35,.29,.55,.71,.58,1.16Z"
					})] })] })
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
					className: "l",
					cx: 600.03,
					cy: 115.04,
					r: 24.04
				}), /* @__PURE__ */ _jsx("polyline", {
					className: "c",
					points: "599.26 104.37 599.26 120.02 606.8 122.76"
				})] }),
				/* @__PURE__ */ _jsx("path", {
					className: "i",
					d: "M821.55,58.59V248.56c0,1.32,.29,2.57,.81,3.7,1.41,3.05,4.49,5.17,8.06,5.17h96.69c4.89,0,8.87-3.98,8.87-8.87V58.59c0-2.53-1.06-4.81-2.76-6.42-1.59-1.51-3.74-2.44-6.1-2.44h-96.69c-4.89,0-8.87,3.98-8.87,8.87Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M927.11,41.96h-96.69c-9.19,0-16.64,7.45-16.64,16.64V248.56c0,9.19,7.45,16.64,16.64,16.64h96.69c9.19,0,16.64-7.45,16.64-16.64V58.59c0-9.19-7.45-16.64-16.64-16.64Zm8.86,206.6c0,4.89-3.98,8.86-8.86,8.86h-96.69c-4.89,0-8.87-3.98-8.87-8.86V58.59c0-4.89,3.98-8.87,8.87-8.87h18.4s0,.09,0,.13c0,3.36,2.72,6.08,6.08,6.08h47.74c3.36,0,6.08-2.72,6.08-6.08,0-.04,0-.09,0-.13h18.4c4.89,0,8.86,3.98,8.86,8.87V248.56Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M875.62,123.87v7.04c-.04,7.61,6.01,13.85,13.62,14.05,7.19,0,13.18-5.5,13.8-12.66,.11-1.05,.16-3.75,.16-4.81s-.05-3.75-.16-4.8c-.63-7.59-7.3-13.24-14.89-12.6-2.56,.21-5.01,1.14-7.08,2.67-.12,.14-.12,.35,0,.48l2.88,4.78c.09,.14,.27,.18,.4,.09,.02-.01,.04-.03,.05-.04,3.2-2.7,7.99-2.3,10.7,.91,.91,1.08,1.5,2.39,1.71,3.78,.26,3.12,.26,6.25,0,9.37-.51,3.77-3.73,6.58-7.53,6.57-1.97-.03-3.85-.85-5.22-2.26-1.39-1.42-2.17-3.34-2.16-5.33v-7.04c.04-7.63-6.04-13.88-13.67-14.05-7.17,.03-13.13,5.54-13.73,12.68-.16,1.03-.16,3.72-.16,4.8s.03,3.75,.16,4.8c.64,7.59,7.32,13.22,14.91,12.58,2.54-.22,4.97-1.13,7.02-2.65,.13-.13,.14-.34,.03-.48l-2.91-4.77c-.1-.12-.28-.14-.4-.05-3.21,2.7-8,2.29-10.7-.91-.91-1.08-1.5-2.4-1.71-3.8-.26-3.12-.26-6.25,0-9.37,.52-3.75,3.72-6.55,7.51-6.56,1.98,.03,3.86,.84,5.23,2.26,1.39,1.43,2.16,3.34,2.15,5.33h-.02Z"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "e",
						x: 845.61,
						y: 186.19,
						width: 66.3,
						height: 3.15,
						rx: 1.58,
						ry: 1.58
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("rect", {
							className: "e",
							x: 852.39,
							y: 171.24,
							width: 13.27,
							height: 3.15,
							rx: 1.58,
							ry: 1.58
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "e",
							x: 872.13,
							y: 171.24,
							width: 13.27,
							height: 3.15,
							rx: 1.58,
							ry: 1.58
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "e",
							x: 891.88,
							y: 171.24,
							width: 13.27,
							height: 3.15,
							rx: 1.58,
							ry: 1.58
						})
					] })
				] })
			]
		})
	]
});
export default SvgEmptyStateOnlineScheduling;
